module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "calendar-menu"
    }
  }, [_c('div', {
    staticClass: "calendar-box-subheader calendar-text-center border-color-skin pc-menu-right"
  }, [_c('div', {
    staticClass: "icon-layout bg-color-skin bg-hover-color-skin-dark-10 border-color-skin-light-20",
    class: {
      'nav-active bg-color-skin-dark-10': _vm.calendarTab1Disp
    },
    on: {
      "click": function($event) {
        _vm.toggleCalendar('calendarTab1Disp')
      }
    }
  }, [_c('a', {
    class: {
      'animated zoomIn fa fa-star star font-white set-position-star': _vm.foundCalendar.tab1, 'animated zoomOut fa fa-star star font-white  set-position-star': !_vm.foundCalendar.tab1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    attrs: {
      "id": "navpc-img1",
      "src": require('static/images/icon_leave.png')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-text"
  }, [_vm._v("Leave")])]), _vm._v(" "), _c('div', {
    staticClass: "icon-layout bg-color-skin bg-hover-color-skin-dark-10 border-color-skin-light-20",
    class: {
      'nav-active bg-color-skin-dark-10': _vm.calendarTab2Disp
    },
    on: {
      "click": function($event) {
        _vm.toggleCalendar('calendarTab2Disp')
      }
    }
  }, [_c('a', {
    class: {
      'animated zoomIn fa fa-star star font-white set-position-star': _vm.foundCalendar.tab2, 'animated zoomOut fa fa-star star font-white  set-position-star': !_vm.foundCalendar.tab2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    attrs: {
      "id": "navpc-img1",
      "src": require('static/images/icon_appointment.png')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-text"
  }, [_vm._v("Appointment")])]), _vm._v(" "), _c('div', {
    staticClass: "icon-layout bg-color-skin bg-hover-color-skin-dark-10 border-color-skin-light-20",
    class: {
      'nav-active bg-color-skin-dark-10': _vm.calendarTab3Disp
    },
    on: {
      "click": function($event) {
        _vm.toggleCalendar('calendarTab3Disp')
      }
    }
  }, [_c('a', {
    class: {
      'animated zoomIn fa fa-star star font-white set-position-star': _vm.foundCalendar.tab3, 'animated zoomOut fa fa-star star font-white set-position-star': !_vm.foundCalendar.tab3
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    attrs: {
      "id": "navpc-img1",
      "src": require('static/images/icon_training.png')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-text"
  }, [_vm._v("Training")])]), _vm._v(" "), _c('div', {
    staticClass: "icon-layout bg-color-skin bg-hover-color-skin-dark-10 border-color-skin-light-20",
    class: {
      'nav-active bg-color-skin-dark-10': _vm.calendarTab4Disp
    },
    on: {
      "click": function($event) {
        _vm.toggleCalendar('calendarTab4Disp')
      }
    }
  }, [_c('a', {
    class: {
      'animated zoomIn fa fa-star star font-white set-position-star': _vm.foundCalendar.tab4, 'animated zoomOut fa fa-star star font-white set-position-star': !_vm.foundCalendar.tab4
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    attrs: {
      "id": "navpc-img1",
      "src": require('static/images/icon_todolist.png')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-text"
  }, [_vm._v("To do list")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c044648!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/calendar_menu_pc.vue
// module id = 3836
// module chunks = 1